import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NguCarouselConfig } from '@ngu/carousel';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { AppConfig } from '../../config-service/app.config';
import { IAnnounceList } from './models/announcements.model';
import { AnnouncementsEntityService } from './ngrx/announcements-entity.service';

@Component({
  selector: 'app-home-announcements',
  templateUrl: './home-announcements.component.html',
  styleUrls: ['./home-announcements.component.css'],
})
export class HomeAnnouncementsComponent implements OnInit {

  apiSettings = AppConfig.settings;
  isLoading = false;
  public carouselTileItems: Array<any> = [];
  public carouselTile: NguCarouselConfig = {
    grid: { xs: 1, sm: 1, md: 1, lg: 1, all: 0 },
    slide: 1,
    speed: 250,
    point: {
      visible: true,
    },
    load: 2,
    velocity: 0,
    touch: true,
    easing: 'cubic-bezier(0, 0, 0.2, 1)',
  };

  messages:any;
  getData:any;
  AlertData:any;
  message:any;
  lat = 36.89766911322062;
  lng = 30.713032319359606;
  zoom=14;

  public pholder: Array<IAnnounceList> = [];

  private subscriptions = new Subscription();
  
  constructor(
    private router:ActivatedRoute, 
    private announcementsEntityService:AnnouncementsEntityService,
    private cd:ChangeDetectorRef,
    private translate:TranslateService
  ) { }

  ngOnInit(): void {
    this.message=this.router.snapshot.params.id;
    this.getAlert(this.message);
    this.cd.detectChanges();

    // this.translate.get('HOME_ANNOUNCEMENTS_NO_ANNOUNCEMENTS_LABEL').subscribe(
    //   noAnnouncementPlaceholder => {        
    //     if(this.carouselTileItems.length == 0){
    //       this.pholder.push({
    //         title: noAnnouncementPlaceholder,
    //         description: ""
    //       } as IAnnounceList);
  
    //       this.carouselTileItems = this.pholder;
    //     }
    //   }
    // )
  }

  getAlert(message:any):void {
    this.isLoading = true;
    this.announcementsEntityService.entities$.subscribe((data:IAnnounceList[]) => {
      this.isLoading = false;
      this.getData=JSON.stringify(data);
      this.AlertData=JSON.parse(this.getData);
      this.carouselTileItems = [];

      this.AlertData.forEach((el:IAnnounceList) => {
        this.carouselTileItems.push(el);
      });
    },
    (err:any) => {
      this.isLoading = false;
      this.getData=JSON.parse(err.error).message;
    });
  };

}